import {ModuleWithProviders} from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MetaGuard } from '@ngx-meta/core';

import { PageNotFoundComponent } from './page-not-found-component/page-not-found-component.component';
import {HomeComponent} from './home/home.component';
import {AboutComponent} from './about/about.component';
import {FeaturesComponent} from './features/features.component';
import {RoomsComponent} from './rooms/rooms.component';
import {SwimingPoolComponent} from './swiming-pool/swiming-pool.component';
import {BarComponent} from './bar/bar.component';
import {RestaurantComponent} from './restaurant/restaurant.component';
import {SpecialOfferComponent} from './special-offer/special-offer.component';
import {ConstuctUsComponent} from './constuct-us/constuct-us.component';
import {ConferenceHallComponent} from './conference-hall/conference-hall.component';

export const router: Routes = [
  {path: '',  redirectTo: '/home', pathMatch: 'full' },
  {path: 'home',  component: HomeComponent },
  {path: 'about/hotel',  component: AboutComponent },
  {path: 'about/features',  component: FeaturesComponent },
  {path: 'about/conference-hall',  component: ConferenceHallComponent },
  {path: 'room/:buildingId/:id',  component: RoomsComponent },
  {path: 'swiming-pool',  component: SwimingPoolComponent },
  {path: 'bar',  component: BarComponent },
  {path: 'restaurant',  component: RestaurantComponent },
  {path: 'special-offers',  component: SpecialOfferComponent },
  {path: 'contact-us',  component: ConstuctUsComponent },
  {path: '**',  component: PageNotFoundComponent }

];

export const routes: ModuleWithProviders = RouterModule.forRoot(router);




// WEBPACK FOOTER //
// C:/Users/HP Spectre/Desktop/Regineh Hotel/reginehUser/src/app/app.routs.ts